import { Popover } from '@headlessui/react';
import ToastStack from 'components/desktop/shared/toast-stack';
import { IconCopy, IconMessageCircle } from 'components/icons';
import { MAIN_DOMAIN, ZALO_OA_ID } from 'globalConstants';
import { useScript, useToast } from 'hooks';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { fixZaloJSV2Error } from 'utils/fix-zalojs2-error';

const SharePostPopover = () => {
  const { asPath } = useRouter();
  const url = `${MAIN_DOMAIN}${asPath}`;
  const { toasts, addToast, removeToast } = useToast();

  const copyText = (text: string) => {
    navigator.clipboard.writeText(text);
    addToast('success', 'Sao chép thành công!');
  };
  const shareViaMessenger = () => {
    addToast('information', 'Chức năng đang được hoàn thiện!');
  };
  const shareViaMessage = () => {
    addToast('information', 'Chức năng đang được hoàn thiện!');
  };

  useScript('https://sp.zalo.me/plugins/sdk.js');
  fixZaloJSV2Error();

  return (
    <Popover.Panel
      static
      id='share-post-popover'
      className='absolute top-full left-1/2 w-[488px] min-w-[488px] translate-x-[-50%] translate-y-[20px] space-y-[24px] rounded-[8px] bg-paper p-[24px] shadow-4'
    >
      <div className='flex flex-col space-y-[24px]'>
        <span className='select-none text-[16px] font-[600] leading-[20px]'>
          Chọn kênh bạn muốn chia sẻ
        </span>
        <div className='flex justify-between'>
          <Link
            href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
            target='_blank'
            rel='noopener noreferrer'
            className='flex-1/5 flex w-full flex-col items-center space-y-[8px]'
          >
            <div className='h-[25px] w-[25px] bg-[url("/icons/facebook.svg")] bg-cover bg-center bg-no-repeat' />
            <span className='leading-[16px]'>Facebook</span>
          </Link>
          <button
            type='button'
            className='flex-1/5 flex w-full flex-col items-center space-y-[8px]'
            onClick={shareViaMessenger}
          >
            <div className='h-[25px] w-[25px] bg-[url("/icons/messenger.svg")] bg-cover bg-center bg-no-repeat'></div>
            <span className='leading-[16px]'>Messenger</span>
          </button>
          <button
            type='button'
            className='flex-1/5 relative flex w-full flex-col items-center space-y-[8px]'
            dangerouslySetInnerHTML={{
              __html: `<div
                  class='zalo-share-button space-y-[8px]'
                  data-oaid='${ZALO_OA_ID}'
                  data-href='${url}'
                  data-customize='true'
                  data-share-type='1'
                ><div class='h-[25px] w-[25px] bg-[url("/icons/zalo.svg")] bg-cover bg-center bg-no-repeat'></div>
                <span class='select-none block leading-[16px]'>Zalo</span></div>`,
            }}
          />
          <Link
            href={`mailto:?subject=&body=${url}`}
            target='_blank'
            rel='noopener noreferrer'
            className='flex-1/5 flex w-full flex-col items-center space-y-[8px]'
          >
            <div className='h-[25px] w-[25px] bg-[url("/icons/google.svg")] bg-cover bg-center bg-no-repeat'></div>
            <span className='leading-[16px]'>Gmail</span>
          </Link>
          <button
            type='button'
            className='flex-1/5 flex w-full flex-col items-center space-y-[8px]'
            onClick={shareViaMessage}
          >
            <IconMessageCircle className='min-h-[29px] min-w-[29px] text-[#2275f1]' />
            <span className='leading-[16px]'>Tin nhắn</span>
          </button>
        </div>
      </div>
      <div className='flex items-center space-x-[10px]'>
        <div className='h-[1px] w-full bg-stroke' />
        <span className='select-none text-[12px] italic leading-[15px] text-text2'>hoặc</span>
        <div className='h-[1px] w-full bg-stroke' />
      </div>
      <div className='flex flex-col space-y-[24px]'>
        <span className='font-[600]'>
          Sao chép đường dẫn phía dưới để gửi cho người bạn muốn chia sẻ
        </span>
        <div className='flex space-x-[10px]'>
          <div className='flex w-full min-w-0 items-center rounded-[6px] border border-stroke px-[8px]'>
            <span className='select-none truncate text-placeholder'>{url}</span>
          </div>
          <button
            type='button'
            className='flex min-w-[116px] items-center justify-center space-x-[12px] rounded-[6px] bg-primary py-[7px] text-paper transition duration-[200ms] ease-in-out hover:bg-primary-light'
            onClick={() => {
              copyText(url);
            }}
          >
            <span className='font-[600]'>Sao chép</span>
            <IconCopy className='h-[18px] w-[18px] text-paper' />
          </button>
        </div>
      </div>
      <ToastStack toasts={toasts} removeToast={removeToast} />
    </Popover.Panel>
  );
};

export default SharePostPopover;
